"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.createCommonPageTimings = void 0;
var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/toConsumableArray"));
var _sendMetrics = require("./sendMetrics");
var _metrics = require("./metrics");
var createCommonPageTimings = exports.createCommonPageTimings = function createCommonPageTimings(timingStart) {
  var timeInSecondsSinceTimingStart = function timeInSecondsSinceTimingStart() {
    var time = new Date().getTime();
    return (time - timingStart) / 1000;
  };
  var getTimingMetrics = {
    getOnAppLoading: function getOnAppLoading(labels) {
      return (0, _metrics.observeTiming)('app_loading', timeInSecondsSinceTimingStart(), labels);
    },
    getOnAppInteractive: function getOnAppInteractive(labels) {
      return (0, _metrics.observeTiming)('app_interactive', timeInSecondsSinceTimingStart(), labels);
    },
    getOnAppComplete: function getOnAppComplete(labels) {
      return (0, _metrics.observeTiming)('app_complete', timeInSecondsSinceTimingStart(), labels);
    }
  };
  var timingMetricsSetters = function timingMetricsSetters(sender, batchSendOnAppComplete) {
    var initialActions = [];
    var saveOrSendTimingMetric = function saveOrSendTimingMetric(timingMetric) {
      if (batchSendOnAppComplete) {
        var _context;
        initialActions = (0, _concat.default)(_context = []).call(_context, (0, _toConsumableArray2.default)(initialActions), [timingMetric]);
      } else {
        sender.sendMetric(timingMetric);
      }
    };
    return {
      setOnAppLoading: function setOnAppLoading(labels) {
        saveOrSendTimingMetric(getTimingMetrics.getOnAppLoading(labels));
      },
      setOnAppInteractive: function setOnAppInteractive(labels) {
        saveOrSendTimingMetric(getTimingMetrics.getOnAppInteractive(labels));
      },
      setOnAppComplete: function setOnAppComplete(labels) {
        saveOrSendTimingMetric(getTimingMetrics.getOnAppComplete(labels));
        if (batchSendOnAppComplete) {
          sender.sendMetrics(initialActions);
        }
      }
    };
  };
  return {
    applyAutoSend: function applyAutoSend(teamName, appName, batchSendOnAppComplete) {
      return timingMetricsSetters((0, _sendMetrics.generateSendMetricsImmediatelyForApp)(teamName, appName), batchSendOnAppComplete);
    },
    applyExistingSender: function applyExistingSender(sender) {
      return timingMetricsSetters(sender, false);
    },
    getMetrics: function getMetrics() {
      return getTimingMetrics;
    }
  };
};
//# sourceMappingURL=createCommonPageTimings.js.map